module.exports = __webpack_public_path__ + "img/NHN-COMMERCE_Horizontal.9984b988.png";